import { IRelationshipType, RelationshipTypeModel } from '@common/models';
import { IModel, Model, ModelRecord } from './Model';
import { StringUtility } from '@common/utils';

export interface IClientAuthorizedUsersModel extends IModel {
  clientAuthorizedUserId: number;
  clientId: number;
  relationshipTypeId?: number | undefined;
  relationshipType: IRelationshipType | undefined;
  name: string;
  phone: string;
}

export class ClientAuthorizedUsersModel
  extends Model
  implements ModelRecord<IClientAuthorizedUsersModel>
{
  clientAuthorizedUserId: number;
  clientId: number;
  relationshipTypeId: number | undefined;
  relationshipType: IRelationshipType | undefined;
  name: string;
  phone: string;

  constructor(params: Partial<IClientAuthorizedUsersModel>) {
    super(params);
    this.clientAuthorizedUserId = _.defaultTo(
      params?.clientAuthorizedUserId,
      0,
    );
    this.clientId = _.defaultTo(params?.clientId, 0);
    this.name = _.defaultTo(params?.name, '');
    this.phone = _.defaultTo(params?.phone, '');
    this.relationshipTypeId = StringUtility.SanitizeNumber(
      params?.relationshipTypeId,
    );
    this.relationshipType = params.relationshipType
      ? new RelationshipTypeModel(params.relationshipType)
      : undefined;
  }
}
